import request from '../request'

/*
  乘车人相关接口
  331530    获取乘车人列表
  331531    上传乘车人
*/
export default {
  '331530': (account12306) =>
    request.ticket({
      url: '/gateway/gtgj/daigou',
      auth: 'yes',
      data: {
        pid: 331530,
        account12306: account12306 || ''
      },
      sidFields: ['uid', 'pid']
    }),
  '331531': (passenger) =>
    request.ticket({
      url: '/gateway/gtgj/daigou',
      auth: 'yes',
      method: 'POST',
      data: {
        pid: 331531,
        passenger: JSON.stringify([].concat(passenger))
      },
      sidFields: ['uid', 'pid']
    })
}



// WEBPACK FOOTER //
// ./src/api/passenger.js